<template>
  <div
      class="d2-layout-header-aside-group"
      :class="{grayMode: d2adminState.isGrayMode}">
      <!-- :style="styleLayoutMainGroup" 背景图-->
    <!-- 半透明遮罩 -->
<!--    <div class="d2-layout-header-aside-mask"></div>-->
    <!-- 主体内容 -->
    <div class="d2-layout-header-aside-content" flex="dir:top">

      <!-- 顶栏 -->
      <div class="d2-theme-header header-bar">
        <div class="logo-group"
             :style="{width: d2adminState.isMenuAsideCollapse ? asideWidthCollapse : asideWidth,height:'50px'}">
          <img v-if="d2adminState.isMenuAsideCollapse"
               :src="`${$baseUrl}image/theme/${d2adminThemeActiveSetting.name}/logo/icon-only.png`">
          <img v-else :src="`${$baseUrl}image/theme/${d2adminThemeActiveSetting.name}/logo/all.png`">
        </div>

        <!--  菜单左侧图标  -->
        <div class="top-main-logo" @click="handleMainLogoClick">
          <img :src="`${$baseUrl}mainlogo.png`" class="top-main-logo-image" />
          <!-- <span class="top-main-logo-text">算力城市</span> -->
          <span class="top-main-logo-text"><img src="/image/portalimg/logo_txt.png" style="width: 80px;" /></span>
        </div>

        <div class="menuPhoneicon" style="position: absolute;right: 5%;top: 20px;" @click="toggleMenu">
          <img src="/image/appstore/logo_menu.png" style="width:20px;height:20px;" />
        </div>

       <!-- 遮罩层（可选） -->
      <div v-if="isMenuVisible && isShowMenuHeader" 
        class="menu-mask" 
        @click="hideMenu"
        style="position: fixed; top: 6%; left: 0; width: 100%; height: 94%; background: rgba(255,255,255,1); z-index: 9998;">
      </div>
       

        <!--  主菜单  -->
        <zebra-menu-header 
          class="pcMenu" 
          :menuHeader="d2adminState.menuHeader"
          :currentAppInfo="d2adminState.currentAppInfo" 
        />
        <!--  主菜单  -->
        <zebra-menu-header 
          class="phoneMenu" 
          v-if="isShowMenuHeader" 
          :menuHeader="d2adminState.menuHeader"
          :currentAppInfo="d2adminState.currentAppInfo" 
          v-show="isMenuVisible"
          @mouseleave="hideMenu"
          @menu-item-clicked="handleMenuItemClicked"
          style="z-index: 9999; position: fixed; right: 0; top: 60px;width:100%;"
        />
        <!-- 顶栏右侧 -->
        <div class="d2-header-right" :class="{'hidden': !isMenuVisible}" >
          <!-- <zebra-bigscreen v-if="isShowBigScreen" :bigScreenRouterPath="bigScreenRouterPath" />大屏幕入口按钮 -->
          <d2-header-user @mouseleave="hideMenu" @menu-item-clicked="handleMenuItemClicked" />
        </div>
      </div>

      <!-- 下面 主体 -->
      <div class="d2-theme-container" flex-box="1" flex>
        <!-- 主体 -->
        <div class="d2-theme-container-main" flex-box="1" flex="dir:top">
          <div class="d2-theme-container-main-header" flex-box="0">
            <zebra-tabs v-if="isShowTabs"
                        class="d2-tabs-d2admin"
                        :isShowTabsToggleAside="false"
                        :pageOpenedList="d2adminState.pageOpenedList"
                        :pageCurrent="d2adminState.pageCurrent"
                        @d2adminTagCloseLeft="handleD2adminTagCloseLeft"
                        @d2adminTagCloseRight="handleD2adminTagCloseRight"
                        @d2adminTagCloseOther="handleD2adminTagCloseOther"
                        @d2adminTagCloseAll="handleD2adminTagCloseAll"
                        @d2adminMenuAsideCollapseToggle="$emit('d2adminMenuAsideCollapseToggle')"
                        @d2adminTagClose="handlerD2adminTagClose" />
            <zebra-breadcrumb v-if="isShowBreadcrumb" :menuHeader="d2adminState.menuHeader"
                              :menuAside="d2adminState.menuAside" />
          </div>
          <div class="d2-theme-container-main-body" flex-box="1">
            <transition name="fade-transverse">
              <router-view/>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import zebraMenuSide from './components/menu-side/menu-side'
import zebraMenuHeader from './components/menu-header/menu-header'
import zebraTabs from './components/tabs/tabs'
import zebraBreadcrumb from './components/breadcrumb/breadcrumb'
import zebraFullscreen from './components/header-fullscreen/fullscreen'
import zebraTheme from './components/header-theme/theme'
import zebraHeaderUser from './components/header-user/header-user'
import d2HeaderHelp from './components/header-help'
import ZebraBigscreen from './components/header-bigscreen'

import headerUserHamiportal from "./components/header-user-hamiportal/index.vue";
import menuSlideout from './components/menu-slideout'

export default {
  name: 'ZebraLayoutPublic',
  components: {
    // Slideout,
    zebraMenuSide,
    zebraMenuHeader,
    zebraTabs,
    zebraBreadcrumb,
    zebraFullscreen,
    zebraTheme,
    zebraHeaderUser,
    d2HeaderHelp,
    ZebraBigscreen,
    'd2-menu-slideout': menuSlideout,
    'd2-header-user': headerUserHamiportal
  },
  //mixins: [ResizeMixin],
  props: {
    d2adminState: {
      type: Object,
      required: true
    },
    d2adminThemeActiveSetting: Object,
    d2adminKeepAliveInclude: Array,
    isShowBreadcrumb: Boolean,
    logoTitle: String,
    bigScreenRouterPath: String,
    isShowBigScreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // [侧边栏宽度] 正常状态
      asideWidth: '50px',
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: '0px',
      //侧边栏是否打开标识，用于控制遮罩层
      panelOpen: false,
      //遮罩层关闭侧边栏事件的开关
      panelOpenCloseEvent: false,
      // 是否显示顶栏菜单
      isShowMenuHeader: true,
      isShowTabs: false,

      isMenuVisible: false, // 控制菜单是否显示，默认隐藏
    }
  },
  computed: {
    /**
     * @description 最外层容器的背景图片样式
     */
    styleLayoutMainGroup() {
      return {
        ...this.d2adminThemeActiveSetting.backgroundImage ? {
          backgroundImage: `url('${this.$baseUrl}${this.d2adminThemeActiveSetting.backgroundImage}')`
        } : {}
      }
    }
  },
  methods: {
    // 点击左上角Logo的响应
    handleMainLogoClick() {
      if(this.$route.path !== '/' && this.$route.path !== '/home') this.$router.replace('/home')
    },
    handleSelectTheme(name) {
      //this.d2adminThemeSet(name)
      this.$emit('d2adminThemeSet', name)
    },
    /**
     * @description 登出
     */
    logOff() {
      /*this.d2adminLogout({
          vm: this,
          confirm: true
      })*/
      this.$emit('d2adminLogout', {
        vm: this,
        confirm: true
      })
    },
    handleD2adminTagCloseLeft(params) {
      this.$emit('d2adminTagCloseLeft', params)
    },
    handleD2adminTagCloseRight(params) {
      this.$emit('d2adminTagCloseRight', params)
    },
    handleD2adminTagCloseOther(params) {
      this.$emit('d2adminTagCloseOther', params)
    },
    handleD2adminTagCloseAll(params) {
      this.$emit('d2adminTagCloseAll', params)
    },
    handlerD2adminTagClose(params) {
      this.$emit('d2adminTagClose', params)
    },
    // 以下是手机版布局slideout插件使用的函数
    beforeopen: function () {
      //console.log('beforeopen');
      //打开遮罩效果
      this.panelOpen = true
    },
    open: function () {
      //console.log('slideoutOpen')
      //开启遮罩层点击关闭侧边事件
      this.panelOpenCloseEvent = true
    },
    //关闭侧边栏
    slideoutClose: function () {
      //this.$children[0].slideout.close()
      this.$refs.slideout.slideout.close()
      this.panelOpen = false
    },
    beforeclose: function () {
      //console.log('beforeclose')
      this.panelOpen = false
      this.panelOpenCloseEvent = false
    },
    //内容区域，即遮罩区域的点击事件
    slideoutCloseByOvermask: function () {
      if (this.panelOpenCloseEvent) {
        this.slideoutClose()
      }
    },


    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
      console.log('isMenuVisible:', this.isMenuVisible, 'isShowMenuHeader:', this.isShowMenuHeader);
    },
    hideMenu() {
      this.isMenuVisible = false;
    },
    handleMenuItemClicked(path) {
      // 页面跳转
      this.$router.push(path);

      // 关闭菜单和遮罩层
      this.hideMenu();

    }
    

  }
}
</script>

<style lang="scss">  
// 注册主题（桌面和手机布局通用）
//@import '~@/assets/style/theme/register.scss';
// 注册主题（只用于手机布局）
//@import '~@/assets/style/theme/mobile.scss';

</style>

<style lang="scss" scoped>
.header-bar {
  position: fixed;
  z-index: 99;
  background: rgba(255, 255, 255, 0.95);
  background:#fff;
  width: 100%;
  box-shadow: 4px 4px 10px rgba(247, 247, 247, 0.5);
}
.top-main-logo {
  float: left;
  height: 60px;
  width: 200px;
  display: flex;
  margin-right: 32px;
  margin-left: 8px;
  justify-content: left;
  align-items: center;
  cursor: pointer;
}
.top-main-logo-image {
  width: 40px;
  height: 36px;
  margin-left: 15px;
  margin-top: 0;
  margin-right: 2px;
}
.top-main-logo-text {
  color: #000;
  font-size: 19px;
  font-weight: 500;
  font-family: "Microsoft YaHei", "Sim-Hei", "PingFang SC", "Helvetica Neue", "Helvetica", "Arial", "Hiragino Sans GB", serif;
  text-align: center;
  line-height: 60px;
}
.top-main-logo-text img{
  width: 80px;
  margin-top: 26px;
}

//隐藏显示原有Logo区域
.d2-theme-header .logo-group img {
  display: none;
}

//左侧菜单栏上浮，遮盖原Logo区域
.d2-theme-container .d2-theme-container-aside {
  top: 0px;
}

.sec_mbox {
  //width: 1250px;
  margin: 0 auto;
}

.sec_wrap {
  min-height: 100%;
}

.sec_main {
  overflow: hidden;
  padding-bottom: 333px;
}

.sec_copyright {
  margin-top: -333px;
}

.sec_center {
  text-align: center;
}

/* 清除浮动 */

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: '';
  display: block;
  clear: both;
}

.clearfix {
  zoom: 1;
}


// 顶部Banner区域
.sec_header {
  /*background: -webkit-linear-gradient(#c4e0ff, #e9f5ff);*/
  /*!* Safari 5.1 - 6.0 *!*/
  /*background: -o-linear-gradient(#c4e0ff, #e9f5ff);*/
  /*!* Opera 11.1 - 12.0 *!*/
  /*background: -moz-linear-gradient(#c4e0ff, #e9f5ff);*/
  /*!* Firefox 3.6 - 15 *!*/
  background: linear-gradient(rgba(196, 224, 255, 0.85), rgba(233, 245, 255, 0.85));
  /* 标准的语法 */
}

.sec_header .sec_LogoL {
  width: 546px;
  height: 116px;
  background: url(/image/appstore/logoL.png) no-repeat center;
}

.sec_header .sec_LogoR {
  width: 453px;
  height: 116px;
  margin-right: 48px;
  background: url(/image/appstore/logoR.png) no-repeat center;
}

.clearfix a {
  color: #0162f4;
}

.clearfix a:hover {
  text-decoration: underline;;
}

@media screen and (max-width: 1170px) {
  .sec_header .sec_LogoR {
    margin-right: 10px;
  }
}

@media screen and (max-width: 1100px) {
  .sec_header .sec_LogoR {
    background: none;
  }
}
</style>

<!-- 以下样式是手机slideout和PC布局模式的对应样式代码 -->
<!--手机版本对应页面-->
<style scoped>
@media (min-width: 769px) {
  /* pc版本 */
  .menuPhoneicon{
    display: none;
  }
  .pcMenu{
    display: block;
  }
  .phoneMenu{
    display: none;
  }
}

@media (max-width: 768px) {
  /* 手机版本 */
  .menuPhoneicon{
    display: block;
  }
  .pcMenu{
    display: none;
  }
  .hidden {
    display: none !important;
  }
  .d2-header-right{
    position: relative;
    z-index: 9999;
    height: 120px !important;
    width: 100%;
    top: 375px;
    border-top: 1px solid #c2c2c2;
  }
}

@media screen and (max-width: 1030px) {
  #mobile-bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 40px;
    background-color: #fff;
    backface-visibility: hidden;
    z-index: 2;
    /*display: none;*/
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.25);
  }

  #mobile-bar .menu-button {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 0;
    left: 5px;
    background: url("/image/slideout/menu.png") center center no-repeat;
    background-size: 24px;
  }

  #mobile-bar .logo {
    position: absolute;
    width: 30px;
    height: 30px;
    background: url("/image/appstore/logo-one.png") center center no-repeat;
    top: 5px;
    left: 50%;
    margin-left: -15px;
    background-size: 30px;
  }

  #mobile-bar .loginBtnGroup {
    float: right;
    line-height: 40px;
    height: 40px;
    width: 40px;
    text-align: center;
  }
}
</style>
<style scoped>
/* 桌面版本布局时 */
@media screen and (min-width: 1030px) {
  .slideout-menu {
    display: none;
  }

  #mobile-bar {
    display: none;
  }
}

/* 手机布局时生效 */
@media screen and (max-width: 1030px) {
  .slideoutContainer {
    overflow: hidden;
    position: relative;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  #slideout-view {
    position: relative;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin-top: 40px;
    padding: 0;
    -webkit-overflow-scrolling: touch;
    overflow: auto;
  }

  body {
    width: 100%;
    height: 100%;
  }

  .slideout-menu {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 256px;
    min-height: 100vh;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    z-index: 0;
    display: none;
    background: #545c64;
  }

  .slideout-menu .el-menu {
    border-right: none;
  }

  .slideout-menu-left {
    left: 0;
  }

  .slideout-menu-right {
    right: 0;
  }

  .slideout-panel {
    position: relative;
    /*z-index: 1;*/
    /*will-change: transform;*/
    background-color: #FFF; /* A background-color is required */
    min-height: 100vh;
    overflow: auto;
  }

  .slideout-open,
  .slideout-open body,
  .slideout-open .slideout-panel {
    overflow: hidden;
  }

  .slideout-open .slideout-menu {
    display: block;
  }

  .fixed-header {
    position: fixed;
    width: 100%;
    height: 50px;
    backface-visibility: hidden;
    z-index: 2;
    /*background-color: red;*/
  }

  /* add an overlay to close the menu on click */
  .panel:before {
    content: '';
    display: block;
    background-color: rgba(0, 0, 0, 0);
    transition: background-color 0.5s ease-in-out;
  }

  .panel-open:before {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, .5);
    z-index: 99;
  }

  /* begin-手机版隐藏或改变PC版部分元素 */
  .d2-theme-container-main-header {
    display: none;
  }

  .sec_header {
    display: none;
  }

  .d2-theme-header {
    display: block;
  }
  /* .el-menu--horizontal.el-menu{
    display: none;
  } */
  .slideoutContainerParent {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .d2-layout-header-aside-group {
    position: static;
  }

  .d2-layout-header-aside-group .d2-layout-header-aside-content .d2-theme-container .d2-theme-container-main {
    position: static;
  }

  .d2-layout-header-aside-group .d2-layout-header-aside-content .d2-theme-container .d2-theme-container-main .d2-theme-container-main-body {
    position: static;
  }

  /* end-手机版隐藏或改变PC版部分元素 */
}

</style>
